import React from "react";

function FieldCard({ label, value }) {
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5 transition-all duration-200 hover:shadow-md hover:-translate-y-1">
      <div className="text-sm font-medium text-slate-500 mb-2">
        {label}
      </div>

      <div className="text-base font-semibold text-slate-800 break-words">
        {value || "-"}
      </div>
    </div>
  );
}

function PartyDetail({ party, agreementData }) {
  const isLegacy = agreementData.data.json.isLegacy;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 mt-5 mb-8">
      {!party.entityType && !isLegacy && (
        <>
          <FieldCard
            label="Individual Name"
            value={party.indi_name}
          />

          <FieldCard
            label="Email"
            value={party.indi_email}
          />
        </>
      )}

      {!party.entityType && isLegacy && (
        <FieldCard
          label="Individual Name"
          value={party.indi_name}
        />
      )}

      {party.entityType && !isLegacy && (
        <>
          <FieldCard
            label="Entity Type"
            value={party.entityType}
          />

          <FieldCard
            label="Registered Name"
            value={party.name}
          />

          <FieldCard
            label="Authorised Signatory Name"
            value={party.signatory}
          />

          <FieldCard
            label="Authorised Signatory Email"
            value={party.email}
          />
        </>
      )}

      {party.entityType && isLegacy && (
        <>
          <FieldCard
            label="Entity Type"
            value={party.entityType}
          />

          <FieldCard
            label="Registered Name"
            value={party.name}
          />
        </>
      )}
    </div>
  );
}

export default PartyDetail;